/**
 * Roundelsphere global interactions
 * Asset: roundelsphere.js
 */

(() => {
  const SELECTOR = "[data-rs-reveal]";

  function revealAll() {
    document.querySelectorAll(SELECTOR).forEach((element) => {
      element.classList.add("rs-is-visible");
    });
  }

  function initializeRevealAnimations(root = document) {
    const elements = Array.from(root.querySelectorAll(SELECTOR));

    if (!elements.length) return;

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (reduceMotion || !("IntersectionObserver" in window)) {
      elements.forEach((element) => {
        element.classList.add("rs-is-visible");
      });

      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add("rs-is-visible");
          currentObserver.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: "0px 0px -8% 0px",
        threshold: 0.08
      }
    );

    elements.forEach((element) => observer.observe(element));
  }

  function initialize() {
  initializeRevealAnimations(document);
  initializeRoundelsphereHeaders(document);
}

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, {
      once: true
    });
  } else {
    initialize();
  }

  document.addEventListener("shopify:section:load", (event) => {
  initializeRevealAnimations(event.target);
  initializeRoundelsphereHeaders(event.target);
});

  document.addEventListener("shopify:section:reorder", revealAll);
    function initializeRoundelsphereHeaders(root = document) {
    const headers = root.querySelectorAll("[data-rs-header]");

    headers.forEach((header) => {
      if (header.dataset.rsInitialized === "true") return;

      header.dataset.rsInitialized = "true";

      const mobileMenu = header.querySelector("[data-rs-mobile-menu]");
      const openButton = header.querySelector("[data-rs-menu-open]");
      const closeButton = header.querySelector("[data-rs-menu-close]");
      const backdrop = header.querySelector("[data-rs-menu-backdrop]");
      const submenuButtons = header.querySelectorAll(
        "[data-rs-submenu-toggle]"
      );

      function openMenu() {
        if (!mobileMenu || !openButton) return;

        mobileMenu.classList.add("is-open");
        mobileMenu.setAttribute("aria-hidden", "false");
        openButton.setAttribute("aria-expanded", "true");
        document.body.classList.add("rs-menu-open");

        window.setTimeout(() => {
          closeButton?.focus();
        }, 100);
      }

      function closeMenu() {
        if (!mobileMenu || !openButton) return;

        mobileMenu.classList.remove("is-open");
        mobileMenu.setAttribute("aria-hidden", "true");
        openButton.setAttribute("aria-expanded", "false");
        document.body.classList.remove("rs-menu-open");

        openButton.focus();
      }

      openButton?.addEventListener("click", openMenu);
      closeButton?.addEventListener("click", closeMenu);
      backdrop?.addEventListener("click", closeMenu);

      submenuButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const submenu = button.nextElementSibling;
          const isOpen =
            button.getAttribute("aria-expanded") === "true";

          button.setAttribute(
            "aria-expanded",
            String(!isOpen)
          );

          if (submenu) {
            submenu.hidden = isOpen;
          }
        });
      });

      document.addEventListener("keydown", (event) => {
        if (
          event.key === "Escape" &&
          mobileMenu?.classList.contains("is-open")
        ) {
          closeMenu();
        }
      });

      function updateHeaderState() {
        const isScrolled = window.scrollY > 24;

        header.classList.toggle(
          "rs-header-is-scrolled",
          isScrolled
        );

        if (
          header.dataset.transparentHome === "true" &&
          isScrolled
        ) {
          header.classList.add("rs-header-is-fixed");
        } else {
          header.classList.remove("rs-header-is-fixed");
        }
      }

      updateHeaderState();

      window.addEventListener("scroll", updateHeaderState, {
        passive: true
      });
    });
  }
})();